import { render, staticRenderFns } from "./drawBarCanvas.vue?vue&type=template&id=b796778c&scoped=true"
import script from "./drawBarCanvas.vue?vue&type=script&lang=js"
export * from "./drawBarCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b796778c",
  null
  
)

export default component.exports